/**
 * @module Section-Blog-Sidebar
 */

import { NavLink, useParams } from "react-router-dom";
import { navUrl } from "../../../globals/common-functions";
import { route } from "../../../globals/constants";
import { TypeSectionBlogSidebar } from "../../@types/sectionTypes";
import AvertImage from "../../../globals/elements/avertimg";
import SectionContactAdvert from "../contact/contact-advert";

/**
 * 
 * @param props : Data supplied to display sidebar
 * @returns Markup for sample sidebar
 */
const SectionBlogsSidebar = (props: {
    _data: TypeSectionBlogSidebar
}) => {
    const { news } = props._data;
    const { blogId } = useParams<{ blogId: string }>();

    // Our services list
    const ourServices = [
        { title: "IT Consultancy", url: navUrl.services(route.services.IT_CONSULTANCY) },
        { title: "Custom Software Development", url: navUrl.services(route.services.CUSTOM_SOFTWARE) },
        { title: "Mobile & Web Development", url: navUrl.services(route.services.MOBILE_DEVELOPMENT) },
        { title: "Payment Gateway Solutions", url: navUrl.services(route.services.PAYMENT_GATEWAY) },
        { title: "IT Security & Training", url: navUrl.services(route.services.IT_SECURITY) }
    ];

    // Helper function to create blog detail URL with ID
    const getBlogDetailUrl = (blogId: string) => {
        return `/blog/${blogId}`;
    };

    // Get random 3 blogs excluding current blog
    const getRandomBlogs = () => {
        if (!news || news.length === 0) return [];
        
        // Filter out current blog
        const filteredNews = news.filter((item) => item.id !== blogId);
        
        // Shuffle and take 3
        const shuffled = [...filteredNews].sort(() => 0.5 - Math.random());
        return shuffled.slice(0, 3);
    };

    const randomBlogs = getRandomBlogs();

    return (
        <div className="side-bar sx-bg-white">
            {/* Services list  */}
            <div className="widget widget_services ">
                <h4 className="widget-title">Our Services</h4>
                <ul className="bg-white">
                    {
                        ourServices.map((_item, _index) => {
                            return (
                                <li key={_index}>
                                    <NavLink to={_item.url}>
                                        {_item.title}
                                    </NavLink>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>

            {/* LATEST INSIGHTS */}
            <div className="widget widget-news-post">
                <h4 className="widget-title">Latest Insights</h4>
                <div className="section-content">
                    <div className="widget-post-bx">
                        {
                            randomBlogs.map((_item, _index) => {
                                return (
                                    <div key={_index} className="av-news-post">
                                        <div className="wt-post-media">
                                            <NavLink to={_item.id ? getBlogDetailUrl(_item.id) : navUrl.blogs(route.blogs.DETAIL)}>
                                                <AvertImage src={_item.image} alt={_item.title || ""} /> 
                                            </NavLink>
                                        </div>
                                        <div className="av-post-info">
                                            <div className="av-post-head">
                                                <div className="post-categories">
                                                    <NavLink to={_item.id ? getBlogDetailUrl(_item.id) : navUrl.blogs(route.blogs.DETAIL)}>
                                                        {_item.category}
                                                    </NavLink>
                                                </div>
                                            </div>
                                            <h3 className="post-title">
                                                <NavLink to={_item.id ? getBlogDetailUrl(_item.id) : navUrl.blogs(route.blogs.DETAIL)}>
                                                    {_item.title}
                                                </NavLink>
                                            </h3>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>

            {/* advertisement */}
            <SectionContactAdvert />
        </div>
    )
}

export default SectionBlogsSidebar;